export function normalizeDeviceSession(deviceId: string) {
  const parts = deviceId.split("|")

  if (
    parts.length >= 5 &&
    /^\d+$/.test(parts[1]!) &&
    /^\d+$/.test(parts[2]!) &&
    /^[a-z]{2}(?:[-_][A-Z]{2})?$/
  ) {
    // Matched that part 1 and 2 of id are digits, and the next is a locale, and we should then remove the screen width and height
    parts.splice(1, 2)
  }

  return parts.join("|")
}

/**
 * We have removed the screen size from the new deviceIds we create, and we don't want user so get in
 * device conflict with their previous and new deviceId.
 */
export function areDeviceSessionsEqual(sessionA: string, sessionB: string) {
  return normalizeDeviceSession(sessionA) === normalizeDeviceSession(sessionB)
}
